const session = window.Session || {};
const auth = window.Auth || {};
const getApiUri = () => {
  let parser = document.createElement("a");
  parser.href = window.location;
  return "//" + parser.host;
};
export const apiCredentials = () => {
  return {
    uri: session.API_URI || getApiUri(),
    user: session.current_user,
    token: session.api_token,
    orgId: session.organization_id,
  };
};
export const getBasicAuthHeader = () => {
  const api = apiCredentials();
  return "Basic " + btoa(`${api.user}:${api.token}`);
};
export const getCSRFTokenHeader = () => {
  return session.authenticity_token || auth.authenticity_token;
};
